import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Typography,
  Box,
  Grid,
  Divider,
  TextField,
  FormControl,
  FormGroup,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getSchools } from "../../services/schoolService";
import { School } from "../../types/School";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface Props {
  onStartTest: () => void;
}

const PlacementTestEntry: React.FC<Props> = ({ onStartTest }) => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mt: 8, height: "100vh" }}>
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "70vh" }}
        >
          {/* Left Column */}
          <Grid item xs={12} md={4}>
            <Box component="section" sx={{ mb: 4 }}>
              <Typography variant="h4" gutterBottom>
                Welcome to EAP Space®
                <br /> Placement Test
              </Typography>
              <Divider variant="middle" sx={{ mb: 2 }} />

              <Typography variant="body1" gutterBottom>
                Determine the perfect course for you based on your placement
                test results. Click below to start the test and begin your
                English learning journey.
              </Typography>

              {/* Instructions */}
              <Typography variant="body2" color="textSecondary" gutterBottom>
                Instructions:
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                - You will have 20 minutes to complete the test.
              </Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                - Each question can only be answered once.
              </Typography>

              <Box sx={{ mt: 4, display: "flex" }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  size="large"
                  onClick={onStartTest}
                >
                  Start Test
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={8}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src="/placement-test-background.png"
                alt="placement test background"
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default PlacementTestEntry;
